import { gql } from '@apollo/client';

export const CREATE_ROTATIONSPLAN_VORLAGE = gql`
  mutation mitarbeiter_createRotationsplanVorlage(
    $input: mitarbeiter_createRotationsplanVorlageInput!
  ) {
    mitarbeiter_createRotationsplanVorlage(
      createRotationsplanVorlageInput: $input
    ) {
      success {
        rotationsplanVorlage {
          id
        }
      }
      error {
        __typename
        message
      }
    }
  }
`;
